import {defineAsyncComponent} from 'vue';

// LIST
const AllocationImplementListPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/AllocationImplementListPopup.vue'),
);
// LIST
const AllocationImplementSubmitEstListPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementSubmitEstListPopup.vue'),
);
// DETAIL
const BaseAllocationImplementPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/base/BaseAllocationImplementPopup.vue'),
);
const BaseAllocationImplementPtcPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/base/BaseAllocationImplementPtcPopup.vue'),
);
const BaseAllocationImplementDVCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/base/BaseAllocationImplementDVCQPopup.vue'),
);
// Detail tổng hợp
const BaseAllocationSummaryDetail = defineAsyncComponent(() =>
  import('@/views/allocationImplement/base/BaseAllocationSummaryDetail.vue'),
);

// Detail tổng hợp PTC
const BaseAllocationSummaryPtcDetail = defineAsyncComponent(() =>
  import('@/views/allocationImplement/base/BaseAllocationSummaryPtcDetail.vue'),
);

// Detail tổng hợp ĐVCQ
const BaseAllocationSummaryDvcqDetail = defineAsyncComponent(() =>
  import('@/views/allocationImplement/base/BaseAllocationSummaryDvcqDetail.vue'),
);

// Form ẩn hiện cột
const SettingLayoutAllocationSummaryPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/base/SettingLayoutAllocationSummary.vue'),
);
// Form ẩn hiện cột
const SettingLayoutAllocationDynamicColumn = defineAsyncComponent(() =>
  import('@/views/allocationImplement/summary/SettingLayoutAllocationDynamicColumn.vue'),
);
// Popup
const AllocationImplementRevenueBusinessAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRevenueBusinessAddPopup.vue'),
);
const AllocationImplementRevenueBusinessSCQAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRevenueBusinessSCQAddPopup.vue'),
);

const AllocationImplementRevenueBusinessPCQAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRevenueBusinessPCQAddPopup.vue'),
);

const AllocationRecRevenueBusinessAddPopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/AllocationRecRevenueBusinessAddPopup.vue'),
);

const AllocationRecRevenueBusinessProvineAddPopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/AllocationRecRevenueBusinessProvineAddPopup.vue'),
);
const AllocationRecRevenueBusinessSCQHTTCAddPopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/AllocationRecRevenueBusinessSCQHTTCAddPopup.vue'),
);
const AllocationRecExpenseBusinessSCQHTTCAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/AllocationRecExpenseBusinessSCQHTTCAddRegularPopup.vue'),
);
const AllocationImplementRevenueFeesAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRevenueFeesAddPopup.vue'),
);
const AllocationImplementRegularFieldAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRegularFieldAddPopup.vue'),
);
const AllocationImplementRegularSourceAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRegularSourceAddPopup.vue'),
);
const AllocationImplementRegularOrgChildPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRegularOrgChildPopup.vue'),
);
const AllocationImplementExpenseBusinessOrgChildPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementExpenseBusinessOrgChildPopup.vue'),
);
const AllocationImplementExpenseBusinessAddInvestPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementExpenseBusinessAddInvestPopup.vue'),
);
const AllocationImplementExpenseBusinessAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementExpenseBusinessAddRegularPopup.vue'),
);
const AllocationImplementInvestSourceDetailAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementInvestSourceDetailAddPopup.vue'),
);
const AllocationImplementInvestDistricSourceDetailAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementInvestDistricSourceDetailAddPopup.vue'),
);
const AllocationImplementInvestSourceAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementInvestSourceAddPopup.vue'),
);
const AllocationImplementInvestDistricSourceAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementInvestDistricSourceAddPopup.vue'),
);
const AllocationImplementRegularStandardPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRegularStandardPopup.vue'),
);
const AllocationImplementRegularExpenseAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRegularExpenseAddPopup.vue'),
);
const AllocationImplementRegularSourceModifiedPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementRegularSourceModifiedPopup.vue'),
);
const AllocationImplementAddContentExpenseInvestPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/expenseInvest/AllocationImplementAddContentExpenseInvestPopup.vue'),
);
const AllocationImplementListPreviewAttachmentPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementListPreviewAttachmentPopup.vue'),
);

const AllocationImplementPTCRevenueFeesAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementPTCRevenueFeesAddPopup.vue'),
);
const AllocationImplementSCQRevenueFeesAddPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementSCQRevenueFeesAddPopup.vue'),
);

const AllocationImplementExpenseFeesAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementExpenseFeesAddRegularPopup.vue'),
);
const AllocationReceiveSelfAddContentExpenseFeesPopup = defineAsyncComponent(() =>
  import('@/views/allocationReceiveSelf/expenseFees/AllocationReceiveSelfAddContentExpenseFeesPopup.vue'),
);
const AllocationReceiveSelfAddContentExpenseFeesSCQAutonomyPopup = defineAsyncComponent(() =>
  import('@/views/allocationReceiveSelf/expenseFees/AllocationReceiveSelfAddContentExpenseFeesSCQAutonomyPopup.vue'),
);
const AllocationReceiveSelfAddContentExpenseFeesSCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationReceiveSelf/expenseFees/AllocationReceiveSelfAddContentExpenseFeesSCQPopup.vue'),
);
const AllocationImplementRegularSummaryBalancePopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementRegularSummaryBalancePopup.vue'),
);

const AllocationImplementExpenseFeesPTCAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementExpenseFeesPTCAddRegularPopup.vue'),
);
const AllocationImplementExpenseFeesDVCQAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementExpenseFeesDVCQAddRegularPopup.vue'),
);
const AllocationImplementExpenseFeesPTCAddInvestPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementExpenseFeesPTCAddInvestPopup.vue'),
);

const AllocationImplementBudgetDetailPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementBudgetDetailPopup.vue'),
);
const AllocationImplementBudgetDetailPopupPTC = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementBudgetDetailPopupPTC.vue'),
);

// Chi khác theo quy định của pháp luật
const AllocationImplementExpenseOtherAddExpenseOther = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/expenseOther/AllocationImplementExpenseOtherAddExpenseOther.vue'),
);
const AllocationImplementExpenseOtherAddExpenseOtherDistrictSTC = defineAsyncComponent(() =>
  import(
    '@/views/allocationImplement/popup/expenseOther/AllocationImplementExpenseOtherAddExpenseOtherDistrictSTC.vue'
  ),
);
const AllocationImplementExpenseOther030 = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/expenseOther/AllocationImplementExpenseOther030.vue'),
);
const AllocationImplementExpenseOtherReserveDistrictSTC = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/expenseOther/AllocationImplementExpenseOtherReserveDistrictSTC.vue'),
);
const AllocationImplementExpenseOther040 = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/expenseOther/AllocationImplementExpenseOther040.vue'),
);
const AllocationImplementExpenseOtherPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/expenseOther/AllocationImplementExpenseOtherPopup.vue'),
);

const AllocationImplementExpenseOther030PTC = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/expenseOther/AllocationImplementExpenseOther030PTC.vue'),
);
const AllocationImplementExpenseOther040PTC = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/expenseOther/AllocationImplementExpenseOther040PTC.vue'),
);

const AllocationImplementExpenseOtherSalaryDistrictSTC = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/expenseOther/AllocationImplementExpenseOtherSalaryDistrictSTC.vue'),
);

const AllocationImplementExpenseFeesAddInvestPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/AllocationImplementExpenseFeesAddInvestPopup.vue'),
);

const AllocationImplementAdjustSourcePopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/expenseRegular/AllocationImplementAdjustSourcePopup.vue'),
);

const AllocationImplementRegularStandardPtcPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/expenseRegular/AllocationImplementRegularStandardPtcPopup.vue'),
);

const AllocationImplementRegularStandardScqPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/expenseRegular/AllocationImplementRegularStandardScqPopup.vue'),
);

const AllocationImplementSummaryExpenseDetailStc = defineAsyncComponent(() =>
  import('@/views/allocationImplement/popup/summary/AllocationImplementSummaryExpenseDetail.vue'),
);

const BaseAllocationDeliver = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/base/BaseAllocationDeliver.vue'),
);
const BaseAllocationDeliverDetail = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/base/BaseAllocationDeliverDetail.vue'),
);
const BaseAllocationDeliverPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/base/BaseAllocationDeliverPopup.vue'),
);

const BaseAllocationImplementSCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/base/BaseAllocationImplementSCQPopup.vue'),
);

// Detail tổng hợp SCQ
const BaseAllocationSummarySCQDetail = defineAsyncComponent(() =>
  import('@/views/allocationImplement/base/BaseAllocationSummarySCQDetail.vue'),
);

const BaseAllocationDeliverDetailDistrict = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/base/BaseAllocationDeliverDetailDistrict.vue'),
);

const AlcImpAddScqBase = defineAsyncComponent(() => import('@/views/alcImpAdd/scq/base/AlcImpAddScqBase.vue'));
const AlcImpAdjScqBase = defineAsyncComponent(() => import('@/views/alcImpAdj/scq/base/AlcImpAdjScqBase.vue'));

const AlcImpAddRevenueFeesScqAddPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddRevenueFeesScqAddPopup.vue'),
);
const AlcImpOrganizationSourceConfigPopup = defineAsyncComponent(() =>
  import('@/views/allocationImplement/AlcImpOrganizationSourceConfigPopup.vue'),
);

const AlcImpAddExpenseFeesScqAddPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddExpenseFeesScqAddPopup.vue'),
);

const AlcImpAddRevenueBusinessScqAddPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddRevenueBusinessScqAddPopup.vue'),
);

const AlcImpAddExpenseBusinessOrgChildPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddExpenseBusinessOrgChildPopup.vue'),
);

const AlcImpAddExpenseBusinessAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/alcImpAdd/scq/details/popup/AlcImpAddExpenseBusinessAddRegularPopup.vue'),
);

export function registerAllocationImplement(app) {
  app.component('AllocationImplementListPopup', AllocationImplementListPopup);
  app.component('BaseAllocationImplementPopup', BaseAllocationImplementPopup);
  app.component('BaseAllocationImplementPtcPopup', BaseAllocationImplementPtcPopup);
  app.component('BaseAllocationImplementDVCQPopup', BaseAllocationImplementDVCQPopup);
  app.component('BaseAllocationSummaryDetail', BaseAllocationSummaryDetail);
  app.component('BaseAllocationSummaryPtcDetail', BaseAllocationSummaryPtcDetail);
  app.component('BaseAllocationSummaryDvcqDetail', BaseAllocationSummaryDvcqDetail);
  app.component('SettingLayoutAllocationSummary', SettingLayoutAllocationSummaryPopup);

  // Popup
  app.component('AllocationImplementRegularSummaryBalancePopup', AllocationImplementRegularSummaryBalancePopup);
  app.component('AllocationImplementRevenueBusinessAddPopup', AllocationImplementRevenueBusinessAddPopup);
  app.component('AllocationImplementRevenueBusinessSCQAddPopup', AllocationImplementRevenueBusinessSCQAddPopup);
  app.component('AllocationImplementRevenueBusinessPCQAddPopup', AllocationImplementRevenueBusinessPCQAddPopup);
  app.component('AllocationImplementRevenueFeesAddPopup', AllocationImplementRevenueFeesAddPopup);
  app.component('AllocationImplementPTCRevenueFeesAddPopup', AllocationImplementPTCRevenueFeesAddPopup);
  app.component('AllocationImplementSCQRevenueFeesAddPopup', AllocationImplementSCQRevenueFeesAddPopup);
  app.component('AllocationImplementRegularFieldAddPopup', AllocationImplementRegularFieldAddPopup);
  app.component('AllocationImplementRegularSourceAddPopup', AllocationImplementRegularSourceAddPopup);
  app.component('AllocationImplementRegularOrgChildPopup', AllocationImplementRegularOrgChildPopup);
  app.component('AllocationImplementExpenseBusinessAddInvestPopup', AllocationImplementExpenseBusinessAddInvestPopup);
  app.component('AllocationImplementExpenseBusinessAddRegularPopup', AllocationImplementExpenseBusinessAddRegularPopup);
  app.component('AllocationImplementExpenseBusinessOrgChildPopup', AllocationImplementExpenseBusinessOrgChildPopup);
  app.component('AllocationImplementInvestSourceDetailAddPopup', AllocationImplementInvestSourceDetailAddPopup);
  app.component(
    'AllocationImplementInvestDistricSourceDetailAddPopup',
    AllocationImplementInvestDistricSourceDetailAddPopup,
  );
  app.component('AllocationImplementInvestSourceAddPopup', AllocationImplementInvestSourceAddPopup);
  app.component('AllocationImplementInvestDistricSourceAddPopup', AllocationImplementInvestDistricSourceAddPopup);
  app.component('AllocationImplementListPreviewAttachmentPopup', AllocationImplementListPreviewAttachmentPopup);
  app.component('AllocationImplementBudgetDetailPopup', AllocationImplementBudgetDetailPopup);
  app.component('AllocationImplementBudgetDetailPopupPTC', AllocationImplementBudgetDetailPopupPTC);
  app.component('AllocationImplementRegularStandardPopup', AllocationImplementRegularStandardPopup);
  app.component('AllocationImplementRegularExpenseAddPopup', AllocationImplementRegularExpenseAddPopup);
  app.component('AllocationImplementRegularSourceModifiedPopup', AllocationImplementRegularSourceModifiedPopup);
  app.component('AllocationImplementSubmitEstListPopup', AllocationImplementSubmitEstListPopup);
  // Chi khác theo quy định của pháp luật
  app.component('AllocationImplementExpenseOtherAddExpenseOther', AllocationImplementExpenseOtherAddExpenseOther);
  app.component(
    'AllocationImplementExpenseOtherAddExpenseOtherDistrictSTC',
    AllocationImplementExpenseOtherAddExpenseOtherDistrictSTC,
  );
  app.component('AllocationImplementExpenseOther030', AllocationImplementExpenseOther030);
  app.component('AllocationImplementExpenseOther040', AllocationImplementExpenseOther040);
  app.component('AllocationImplementExpenseOtherReserveDistrictSTC', AllocationImplementExpenseOtherReserveDistrictSTC);
  // Chi khác theo quy định của pháp luật
  app.component('AllocationImplementExpenseOther030PTC', AllocationImplementExpenseOther030PTC);
  app.component('AllocationImplementExpenseOther040PTC', AllocationImplementExpenseOther040PTC);
  app.component('AllocationImplementExpenseOtherSalaryDistrictSTC', AllocationImplementExpenseOtherSalaryDistrictSTC);
  app.component('AllocationImplementExpenseFeesAddRegularPopup', AllocationImplementExpenseFeesAddRegularPopup);
  app.component('AllocationImplementExpenseFeesAddInvestPopup', AllocationImplementExpenseFeesAddInvestPopup);
  app.component('AllocationImplementAddContentExpenseInvestPopup', AllocationImplementAddContentExpenseInvestPopup);
  app.component('AllocationImplementExpenseFeesPTCAddRegularPopup', AllocationImplementExpenseFeesPTCAddRegularPopup);
  app.component('AllocationImplementExpenseFeesDVCQAddRegularPopup', AllocationImplementExpenseFeesDVCQAddRegularPopup);
  app.component('AllocationImplementExpenseFeesPTCAddInvestPopup', AllocationImplementExpenseFeesPTCAddInvestPopup);
  app.component('AllocationImplementExpenseOtherPopup', AllocationImplementExpenseOtherPopup);
  app.component('AllocationImplementAdjustSourcePopup', AllocationImplementAdjustSourcePopup);
  app.component('AllocationImplementRegularStandardPtcPopup', AllocationImplementRegularStandardPtcPopup);
  app.component('AllocationImplementRegularStandardScqPopup', AllocationImplementRegularStandardScqPopup);
  app.component('AllocationImplementSummaryExpenseDetail', AllocationImplementSummaryExpenseDetailStc);
  app.component('AllocationReceiveSelfAddContentExpenseFeesPopup', AllocationReceiveSelfAddContentExpenseFeesPopup);
  app.component(
    'AllocationReceiveSelfAddContentExpenseFeesSCQPopup',
    AllocationReceiveSelfAddContentExpenseFeesSCQPopup,
  );
  app.component('BaseAllocationDeliver', BaseAllocationDeliver);
  app.component(
    'AllocationReceiveSelfAddContentExpenseFeesSCQAutonomyPopup',
    AllocationReceiveSelfAddContentExpenseFeesSCQAutonomyPopup,
  );
  app.component('BaseAllocationDeliver', BaseAllocationDeliver);
  app.component('BaseAllocationDeliverDetail', BaseAllocationDeliverDetail);
  app.component('BaseAllocationDeliverPopup', BaseAllocationDeliverPopup);
  app.component('SettingLayoutAllocationDynamicColumn', SettingLayoutAllocationDynamicColumn);
  app.component('AllocationRecRevenueBusinessAddPopup', AllocationRecRevenueBusinessAddPopup);
  app.component('AllocationRecRevenueBusinessSCQHTTCAddPopup', AllocationRecRevenueBusinessSCQHTTCAddPopup);
  app.component(
    'AllocationRecExpenseBusinessSCQHTTCAddRegularPopup',
    AllocationRecExpenseBusinessSCQHTTCAddRegularPopup,
  );

  // Sở chủ quản phân bổ
  app.component('BaseAllocationImplementSCQPopup', BaseAllocationImplementSCQPopup);
  app.component('BaseAllocationSummarySCQDetail', BaseAllocationSummarySCQDetail);
  app.component('AllocationRecRevenueBusinessProvineAddPopup', AllocationRecRevenueBusinessProvineAddPopup);

  app.component('BaseAllocationDeliverDetailDistrict', BaseAllocationDeliverDetailDistrict);
  app.component('AlcImpAddScqBase', AlcImpAddScqBase);
  app.component('AlcImpAddRevenueFeesScqAddPopup', AlcImpAddRevenueFeesScqAddPopup);
  app.component('AlcImpAddExpenseFeesScqAddPopup', AlcImpAddExpenseFeesScqAddPopup);
  app.component('AlcImpAddRevenueBusinessScqAddPopup', AlcImpAddRevenueBusinessScqAddPopup);
  app.component('AlcImpAddExpenseBusinessOrgChildPopup', AlcImpAddExpenseBusinessOrgChildPopup);
  app.component('AlcImpAddExpenseBusinessAddRegularPopup', AlcImpAddExpenseBusinessAddRegularPopup);
  //SCQ điều chỉnh phân bổ
  app.component('AlcImpAdjScqBase', AlcImpAdjScqBase);
  app.component('AlcImpOrganizationSourceConfigPopup', AlcImpOrganizationSourceConfigPopup);
}
